<template>
  <v-container fluid>
    <v-row v-if="numbers.length > 0" class="pro-d-rank-row">
      <v-col v-for="i in [0, 1, 2]" v-bind:key="i">
        <div :class="groupClass(i)">
          <v-row>
            <div class="group-title">{{ groupTitles[i] }}</div>
            <v-col v-for="j in [0, 1, 2]" v-bind:key="j">
              <div class="item-value">{{ numbers[i * 3 + j] }}</div>
            </v-col>
          </v-row>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  props: {
    numbers: { type: Array }
  },
  created() {
    this.groupTitles = ["High", "Mid", "Low"]
  },
  methods: {
    groupClass(groupNumber) {
      let s = "grouping"
      if (groupNumber == 0) {
        s += " group-high"
      } else {
        s += " group-other"
      }
      return s
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../scss/variables";

.grouping {
  text-align: center;
  padding: 0 10px;
}

.group-title {
  width: 100%;
  font-size: 2em;
  color: $pro-d-m;
  font-style: italic;
}

.item-value {
  padding: 17px;
  border: 0px solid;
  border-radius: 50px;
  font-size: 1.5em;
  background-color: $white;
  color: $pro-d-m;
}

.group-high {
  background-color: lighten($pro-d-c, 20);
}

.group-other {
  .item-value {
    background-color: lighten($pro-d-c, 20);
  }
}
</style>
